import type { MessagingChannelsCopy } from './types';

export const RU: MessagingChannelsCopy = {
  title: 'Мессенджеры',
  description:
    'Общайтесь с IMAI в мессенджерах, которыми уже пользуетесь. Подключите аккаунт один раз и пишите IMAI прямо там.',
  privacy:
    'Сообщения из подключённых аккаунтов выполняются от вашего имени в этом рабочем пространстве и расходуют ваши кредиты.',
  loading: 'Загрузка мессенджеров',
  unavailable: 'Пока недоступно',
  unavailableNote: '{channel} пока не настроен для IMAI.',
  connectedBadge: 'Подключено',
  cancel: 'Отмена',

  phoneTitle: 'Номер телефона',
  phoneNote: 'Подключите WhatsApp или iMessage с помощью номера телефона.',
  phoneUnavailableNote: 'Сообщения IMAI по телефону пока не настроены.',
  addNumber: 'Добавить номер',
  countryLabel: 'Код страны',
  countrySearch: 'Поиск страны или кода…',
  countryEmpty: 'Страны не найдены.',
  numberLabel: 'Номер телефона',
  numberPlaceholder: 'Номер телефона',
  numberHint: 'Нет вашей страны? Введите полный номер, начиная с +.',
  continueActivation: 'Продолжить',
  editNumber: 'Изменить номер',
  activateQr: 'Отсканируйте и отправьте для подключения.',
  activateTitle: 'Отправьте одно сообщение в WhatsApp',
  activateHint: 'Нажмите кнопку и отправьте уже заполненное сообщение.',
  activateSentFrom: 'Отправьте его с номера {number}.',
  activateButton: 'Открыть {channel}',
  activateManual: 'Или отправьте {message} на номер {number} в WhatsApp.',
  activateWaiting: 'Ждём ваше сообщение. Истекает через {time}.',
  startAgain: 'Начать заново',
  verifiedBadge: 'Подтверждён',
  verifiedOn: 'Подтверждён {date}',
  change: 'Изменить',
  changeAria: 'Изменить номер {number}',
  remove: 'Удалить',
  removeAria: 'Удалить номер {number}',
  messageImai: 'Написать IMAI',
  messageImaiAria: 'Написать IMAI в {channel}',
  removeTitle: 'Удалить {number}?',
  removeDescription:
    'IMAI перестанет отвечать на этот номер в iMessage и WhatsApp. Его можно добавить снова в любой момент.',
  removeError: 'Не удалось удалить номер. Попробуйте ещё раз.',

  errorInvalidNumber: 'Введите правильный номер вместе с кодом города.',
  errorNumberTaken: 'Этот номер уже используется другим аккаунтом IMAI.',
  errorRateLimited:
    'Слишком много попыток. Подождите немного и попробуйте снова.',
  errorChannelUnavailable: 'Этот способ сейчас недоступен. Выберите другой.',
  errorSendFailed: 'Не удалось начать подтверждение. Попробуйте ещё раз.',
  errorActivationExpired: 'Срок активации истёк. Начните заново.',

  noteSlack: 'Пишите IMAI из своего рабочего пространства Slack.',
  noteTeams: 'Пишите IMAI в Microsoft Teams.',
  noteTelegram: 'Общайтесь с ботом IMAI в Telegram.',
  connect: 'Подключить',
  connectAria: 'Подключить {channel}',
  connectError: 'Не удалось начать подключение {channel}. Попробуйте ещё раз.',
  connectedOn: 'Подключено {date}',
  accountFallback: 'Ваш аккаунт {channel}',
  installSlack: 'Добавить IMAI в рабочее пространство',
  installTeams: 'Добавить IMAI в Teams',
  openTelegram: 'Открыть в Telegram',
  disconnect: 'Отключить',
  disconnectAria: 'Отключить {account} от {channel}',
  disconnectError: 'Не удалось отключить {channel}. Попробуйте ещё раз.',
  disconnectTitle: 'Отключить {channel}?',
  disconnectDescription:
    'Сообщения от {account} перестанут доходить до IMAI. Подключить аккаунт снова можно в любой момент.',

  toastConnected: '{channel} подключён',
  toastConnectedGeneric: 'Аккаунт подключён',
  toastErrorExpired: 'Вход занял слишком много времени. Попробуйте снова.',
  toastErrorInvalidState:
    'Эта ссылка для входа больше не действует. Попробуйте снова.',
  toastErrorAccountTaken:
    'Этот аккаунт уже подключён к другому пользователю IMAI.',
  toastErrorNotMember: 'Вы больше не участник этого рабочего пространства.',
  toastErrorProvider: 'Вход не завершён. Попробуйте подключиться снова.',
  toastErrorGeneric: 'Не удалось подключить аккаунт. Попробуйте ещё раз.',
};
